export default __webpack_public_path__ + "static/media/tv.9a68d2cd.png";